import JsonApi from "./jsonApi";
import {getBvFeatures, getBvGroupFeatures, getSaveQuoteFastData} from "./server-api";
import {getCurrentLayout, getCurrentRoomType} from "../bvcomponents/appLayout";
import {COUNTERTOP_GROUP, CABINET_GROUP, EDGE_GROUP} from "../bvcomponents/kvComponent/core/constants";
import store from "../store";
import {updateFeatureGroupCount, updateNavigationCount} from "../actions/lookFunctions";
import {CONTEXT_MENU_SHOWER_ALL, COUNTERTOP_GROUP_BATHROOM, LOOK_ROOM_TYPES} from "../bvcomponents/look/core/constants";
import {getCommonVisualizerType, IS_LIXIL_SERVERS} from "../config";
import {getFeatureCost} from "../misc/helpers";
import {showWizardInsteadOfQT} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getApplyToLogic} from "../bvcomponents/look/lookNavigation/lookNavigationFunctions";

export const LIXIL_USER_QUERY_PARAMS = ["userid", "email", "fname", "lname", "brand", "region"];

export const getPassedUserInfo = (searchParams) => {
  // {
  //   userid: {userId from querystring},
  //   email: {email from querystring},
  //   fname: {fname from querystring},
  //   lname: {lname from querystring},
  //   fabricatorId: {QC Id for Fabricator (same value passed for fabricatorId for the LoginClient API call}
  // }
  const userData = {
    fabricatorId: +document.kvConfig.userId
  };
  LIXIL_USER_QUERY_PARAMS.forEach(property => {
    userData[property] = searchParams.get(property)
      ? property === "userid" || property === "lname"
        ? searchParams.get(property).split("?userid=")[0].replace(/ /g, "+")
        : searchParams.get(property).replace(/ /g, "+")
      : ""
  });
  console.log("request userData", userData);
  return JsonApi.getPassedUserInfo(userData)
    .then(response => response.data)
    .catch(error => {
      console.log("Server error getPassedUserInfo "+new Error(error));
    })
};

export const postSaveVisualizerImage = (base64Image) => {
  // console.log("request postSaveVisualizerImage", base64Image);
  return JsonApi.postSaveVisualizerImage(+document.kvConfig.userId, base64Image)
    .then(response => response.data)
    .catch(error => {
      console.log("Server error postSaveVisualizerImage "+new Error(error));
    })
};

export const postSaveTempData = (tempData, id = "", expiresIn = "", ) => {
  return JsonApi.postSaveTempData(tempData, id, expiresIn)
    .then(response => response.data)
    .catch(error => {
      console.log("Server error postSaveTempData "+new Error(error));
    })
};

export const getSaveTempData = (id = "") => {
  return JsonApi.getSaveTempData(id)
    .then(response => response.data)
    .catch(error => {
      debugger;//eslint-disable-line
      console.log("Server error getSaveTempData "+new Error(error));
    })
};

export const getTempIdForPostMessage = async (returnAction = "", existingTempId = "") => {
  const savedFastData = await getSaveQuoteFastData(true);

  savedFastData.records[0].data["returnAction"] = returnAction;
  console.log("request post temp data before stringify ->", existingTempId, savedFastData);
  const stringifiedSaveData = JSON.stringify(savedFastData);
  let receivedTempId = await postSaveTempData(stringifiedSaveData, existingTempId);
  if (!receivedTempId) {
    receivedTempId = await postSaveTempData(stringifiedSaveData, existingTempId);
  }
  return receivedTempId
};

export const postSureTax = (postData) => {
  return JsonApi.postSureTax(postData)
    .then(response => response.data)
    .catch(error => console.log("Server error postSureTax "+new Error(error)))
};

export const postVerifyAddress = (addressObject) => {
  return JsonApi.postVerifyAddress( {
    "Address1": "",
    "Address2": (addressObject.address1 || "").split(",")[0],
    "City" : addressObject.city,
    "State" : addressObject.stateShort || addressObject.state.slice(0, 2),
    "Zip5" : (addressObject.postal || "").split("-")[0] || null,
    "Zip4" : (addressObject.postal || "").split("-")[1] || null
  })
    .then(response => {
      if (response.data.error) {
        return {
          errorDescription: response.data.error
        }
      }
      return response.data
    })
    .catch(error => {
      if (error && error.response && error.response.data && error.response.data.error) {
        return {
          errorDescription: error.response.data.error
        }
      }
      return {
        errorDescription: error && error.message ? error.message : "Server error verifyAddress "+new Error(error)
      }
    })
};

export const getTrumbleShippingOptions = (skuList, zipCode) => {
  return JsonApi.getTrumbleShippingOptions(skuList, zipCode)
    .then(response => response.data)
    .catch(error => console.log("Server error postSureTax "+new Error(error)))
};
export const postTrumbleShippingOptions = (postData, zipCode) => {
  return JsonApi.postTrumbleShippingOptions(postData, zipCode)
    .then(response => response.data)
    .catch(error => console.log("Server error postSureTax "+new Error(error)))
};
export const postTrumbleInventory = (skusArray = []) => {
  // https://qc-cdn.s3.amazonaws.com/lixil/image+(8).png
  return JsonApi.postTrumbleInventory(skusArray)
    .then(response => response.data)
    .catch(error => console.log("Server error postTrumbleInventory "+new Error(error)))
};

export const postShipperHQOptions = async (shippingAddress, cartItems = []) => {
  const {stateShort, state, city, postal} = shippingAddress;
  const postData = {
    destination: {
      "country": "US", // hardcode for now
      "region": stateShort || state.slice(0, 2),
      "city": city,
      "zipcode": postal,
    },
    items: cartItems.map(cartItem => ({
      "itemId": cartItem.cartFeature.dbFeature.id,
      "sku": cartItem.cartFeature.dbFeature.sku,
      "storePrice": getFeatureCost(cartItem.cartFeature, 1, cartItem.fromQtCategory),
      "quantity": cartItem.quantity
    }))
  }
  // https://qc-cdn.s3.amazonaws.com/lixil/image+(10).png
  return JsonApi.postShipperHqShipping(postData)
    .then(response => {
      console.log("response postShipperHqShipping", response && response.data ? response.data : response);
      let availableOptions = [];
      if (!response.data || !Array.isArray(Object.keys(response.data))) {
        return availableOptions
      }
      availableOptions = Object.keys(response.data).map(dbFeatureId => {
        if (!Array.isArray(response.data[dbFeatureId]) || !response.data[dbFeatureId].length) {
          return {dbFeatureId: +dbFeatureId, options: []}
        }
        const options = response.data[dbFeatureId].flatMap(carrier => { // can be several
          return carrier.shippingRates.map(shippingRate => {
            return {
              cost: shippingRate.totalCharges,
              title: shippingRate.title,
              delivery: shippingRate.delivery || "-",
              code: shippingRate.code
            }
          })
        })
        return {dbFeatureId: +dbFeatureId, options}
      })
      return availableOptions
    })
    .catch(error => console.log("Server error postShipperHQOptions "+new Error(error)))
};

/**
 * sets feature quantity properties
 * @param featuresArray {featureInterface}
 * @returns {promise}
 */
export const setTrumbleInventoryForFeatures = (featuresArray = []) => {
  const skusArray = featuresArray.map(feature => feature.dbFeature.sku);
  return postTrumbleInventory(skusArray)
    .then(responseData => {
      // console.log("postTrumbleInventory responseData", responseData);
      if (responseData && responseData.success && responseData.inventory) {
        Object.keys(responseData.inventory).forEach(sku => {
          const featureToUpdate = featuresArray.find(feature => feature.dbFeature.sku === sku);
          if (featureToUpdate) {
            if (!featureToUpdate.quantityOptions) {
              featureToUpdate.quantityOptions = {};
            }
            featureToUpdate.quantityOptions.trumbleQty = responseData.inventory[sku].inventory;
          }
        })
      }
    })
};

const requestMoreThanUsualPartIds = ["vanity_faucet", "vanity_sink", "shower_head", "valve_trim", "diverter_trim", "towel",
  "towel_towel_bar", "towel_towel_hook", "towel_towel_ring", "shower_fixture", "shower_door", "corner_shelf", "shower_pan_combo",
  "large_corner_seat", "vanity_lighting"];

/**
 * common function to request features
 * @param featureGroup {featureGroupInterface}
 * @returns {number}
 */
const request6kFeatures = [...CABINET_GROUP, "top_handle", "bottom_handle", "sink", "center_island_sink", "crown_molding"];
export const getFeaturesPageSize = (featureGroup) => {
  let pageSize = 1000;
  if (document.kvConfig.visualizerType === "kvScene" && request6kFeatures.includes(featureGroup.partId)) {
    pageSize = 6000 // always for new kitchen (we need all parts)
  } else if (COUNTERTOP_GROUP.includes(featureGroup.partId)) {
    const {navigationState} = store.getState();
    if (document.kvConfig.visualizerType !== "kvScene" || navigationState.useFeaturesLightRequest.countertops) {
      pageSize = 6000 // always for old Kitchen
    }
  } else if (
    (document.kvConfig.visualizerType === "bvLook" && requestMoreThanUsualPartIds.includes(featureGroup.partId))
    || (document.kvConfig.visualizerType === "bvScene" && (featureGroup.partId === "shower_wall" || featureGroup.partId === "shower_interior_wall"))
  ) {
    pageSize = 6000
  }
  if (featureGroup.allFeaturesReceived && pageSize === 6000) {
    pageSize = 2000 // next always 2k, it works correctly on scroll
  }
  return pageSize
}

export const getAdditionalFeaturesOnScroll = async (featureGroup, isCommonRequest = false) => {
  if (featureGroup.createdManually || featureGroup.requestInProgress) {
    if (featureGroup.createdManually) {
      featureGroup.allFeaturesReceived = true;
    }
    return false
  }

  featureGroup.requestInProgress = true;
  // console.log("propsPageSize", propsPageSize);
  const pageSize = getFeaturesPageSize(featureGroup);
  const layout = featureGroup.getParent
    ? featureGroup.getParent().layout || getCurrentLayout()
    : getCurrentLayout();
  const layoutAbbr = layout.getCurrentLayoutAbbreviation();
  const nextFeaturesPage = featureGroup.getNextPageToLoad(layoutAbbr);

  if (featureGroup.additionalPartPartId) {
    const wallParent = layout.parts["Walls"];
    const isWallChild = wallParent && wallParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId);
    if (isWallChild) {
      const cropResponse = await getBvGroupFeatures((featureGroup.dbName || featureGroup.partName) + " Crop", nextFeaturesPage, pageSize * 3);
      if (Array.isArray(cropResponse)) {
        featureGroup.setGroupFeatures(cropResponse, pageSize * 2, false, layoutAbbr, nextFeaturesPage, false, !isCommonRequest);
      }
    }
  }

  const response = await getBvGroupFeatures(featureGroup.dbName || featureGroup.partName, nextFeaturesPage, pageSize);

  let responseArray = Array.isArray(response) ? response : [];
  let oldFeatures = [];
  if (layout.isNewLayout && featureGroup.nextFeaturesPageToLoadArray && !featureGroup.allFeaturesReceived && !IS_LIXIL_SERVERS
    && (CABINET_GROUP.includes(featureGroup.partId) || COUNTERTOP_GROUP.includes(featureGroup.partId)
      || COUNTERTOP_GROUP_BATHROOM.includes(featureGroup.partId))) { // we don't need requests for walls
    const {wizardList, wizardIsActive} = store.getState().wizardState;
    if (!showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      const responseWithOldFeatures = await getBvGroupFeatures(featureGroup.dbName || featureGroup.partName, nextFeaturesPage, 6000,  [], "", "", null, true);
      if (Array.isArray(responseWithOldFeatures)) {
        oldFeatures = responseWithOldFeatures;
      }
    }
  }

  featureGroup.setGroupFeatures(responseArray, pageSize, true, layoutAbbr, nextFeaturesPage, false, !isCommonRequest);

  if (oldFeatures.length) {
    featureGroup.setGroupFeatures(oldFeatures, pageSize, false, layoutAbbr, nextFeaturesPage, true, false);
  }
  featureGroup.requestInProgress = false;
  // if (applyCustomConfigurations) { //no need for it right now since we have less than 1000 sinks anf faucets
  //   const vanityParent = layout.parts["Vanity"];
  //   const isVanityChild = vanityParent && vanityParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId);
  //   if (vanityParent) {
  //     layout.createCustomConfigurations();
  //   }
  // }
  return responseArray
};

const allRelatedItemsCheck = (parentGroup, neededParts) => {
  parentGroup.relatedItems.forEach(relItem => {
    if (!relItem.allFeaturesReceived && !neededParts.some(featureGroup => featureGroup.partId === relItem.partId)) {
      neededParts.push(relItem)
    }
  })
  return neededParts
}

/**
 * gets all features depending on the featureGroup
 * @param featureGroup {featureGroupInterface}
 * @param shouldUpdateNavigation {boolean}
 * @param onlyReturnGroups {boolean}
 */
export const checkIfLookFeaturesReceived = async (featureGroup, shouldUpdateNavigation = true, onlyReturnGroups = false) => {
  const layout = featureGroup.getParent
    ? featureGroup.getParent().layout || getCurrentLayout()
    : getCurrentLayout();
  if (!featureGroup.partId) {
    return []
  }
  const layoutAbbr = layout.getCurrentLayoutAbbreviation();
  let neededParts = [];
  let neededFeatureGroup = null;
  if (!featureGroup.allFeaturesReceived
    || (featureGroup.nextFeaturesPageToLoadArray && !featureGroup.nextFeaturesPageToLoadArray[layoutAbbr].page)) {
    neededParts.push(featureGroup);
  }
  // const wallParent = layout.parts["Walls"];
  const vanityParent = layout.parts["Vanity"];
  const cabinetParent = layout.parts["Cabinet"];

  // const isWallChild = wallParent && wallParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId);
  const isVanityChild = vanityParent && vanityParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId);
  const isCabinetChild = cabinetParent
    && (cabinetParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId)
      || featureGroup.partId === "fridge"
      || featureGroup.partId === "dishwasher"
      || featureGroup.partId === "center_island_cabinet"
      || featureGroup.partId === "stovetop"
      || featureGroup.partId === "range"
      || featureGroup.partId === "hood");
  const isCountertop = COUNTERTOP_GROUP.some(partId => partId === featureGroup.partId);
  const isEdge = EDGE_GROUP.some(partId => partId === featureGroup.partId);
  const visType = getCommonVisualizerType();
  const isFaucetOrSink = visType === "kitchen" && (featureGroup.partId.includes("faucet") || featureGroup.partId.includes("sink"));
  const isDoorOrShowerPan = visType === "bathroom" && (featureGroup.partId.includes("shower_door") || featureGroup.partId.includes("shower_pan_combo"));
  // if (isWallChild) {
  //   neededParts = allRelatedItemsCheck(wallParent, neededParts);
  // } else if (isVanityChild) {
  if (isVanityChild) {
    neededParts = allRelatedItemsCheck(vanityParent, neededParts);
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      const wallParent = layout.parts["Walls"];
      if (wallParent) {
        ["frontWall", "rightWall", "leftWall"].forEach(wallId => {
          if (wallParent[wallId] && !wallParent[wallId].allFeaturesReceived) {
            neededParts.push(wallParent[wallId]);
          }
        })
      }
    }
  } else if (isCabinetChild) {
    neededParts = allRelatedItemsCheck(cabinetParent, neededParts);
    if (featureGroup.partId !== "center_island_cabinet") {
      const centerIslandCabinet = layout.getFeatureGroupByPartId("center_island_cabinet");
      if (centerIslandCabinet) {
        neededParts.push(centerIslandCabinet);
      }
    }
  } else if (isCountertop) {
    const countertop = layout.parts["Countertop"] ? layout.parts["Countertop"].countertop : null;
    const backsplash = layout.parts["Walls"] ? layout.parts["Walls"].backsplash : null;
    const centerCountertop = layout.parts["CenterIsland"] ? layout.parts["CenterIsland"].countertop : null;
    const edgeProfile = layout.parts["Countertop"] ? layout.parts["Countertop"].edgeProfile || layout.parts["Countertop"].edge : null;
    [countertop, backsplash, centerCountertop, edgeProfile].forEach(relItem => {
      if (relItem && (relItem.partId !== featureGroup.partId) && !relItem.allFeaturesReceived) {
        neededParts.push(relItem)
      }
    });
    if (featureGroup.partId === "center_island_countertop" && layout.parts["CenterIsland"] && layout.parts["CenterIsland"].sink) {
      neededParts.push(layout.parts["CenterIsland"].sink)
    }
  } else if (isFaucetOrSink) {
    const parent = featureGroup.getParent();
    switch (featureGroup.partId) {
      case "center_island_faucet":
      case "faucet":
        neededFeatureGroup = parent.sink;
        break;
      case "center_island_sink":
      case "sink":
        neededFeatureGroup = parent.faucet;
        break;
      default:
        break;
    }
    if ((featureGroup.partId === "center_island_sink") && parent.countertop) {
      neededParts.push(parent.countertop)
    }
  } else if (isDoorOrShowerPan && (document.kvConfig.visualizerType !== "bvLook")) { //bv5 support
    neededFeatureGroup = featureGroup.partId.includes("shower_door")
      ? featureGroup.getParent().showerPanCombo
      : featureGroup.getParent().showerDoor;
  } else if (CONTEXT_MENU_SHOWER_ALL.includes(featureGroup.partId) && document.kvConfig.visualizerType === "bvLook") {
    CONTEXT_MENU_SHOWER_ALL.forEach(partId => {
      const fg = layout.getFeatureGroupByPartId(partId);
      if (fg) {
        neededParts.push(fg);
      }
    })
  } else if (isEdge) {
    neededFeatureGroup = featureGroup.getParent().countertop;
  } else if (featureGroup.partId === "stove" || featureGroup.partId === "range") {
    if (featureGroup.getParent().hood) {
      neededParts.push(featureGroup.getParent().hood);
    }
    if (featureGroup.getParent().oven) {
      neededParts.push(featureGroup.getParent().oven);
    }
    if (cabinetParent && cabinetParent.bottomCabinet) {
      neededParts.push(cabinetParent.bottomCabinet);
    }
    if (cabinetParent && cabinetParent.bottomHandle) {
      neededParts.push(cabinetParent.bottomHandle);
    }
  } else if (featureGroup.activeFeature) {
    const applyToLogic = getApplyToLogic(featureGroup.activeFeature);
    // console.log("applyToLogic", applyToLogic);
    if (applyToLogic && applyToLogic.type === 'walls' && applyToLogic.applyToArrayAll) {
      // Rebath issue with requesting features - every feature is requested from all groups which is super slow
      applyToLogic.applyToArrayAll.forEach(wallPartId => {
        const subPart = layout.getSubPartByPartId(wallPartId);
        if (subPart && subPart.part.partId === wallPartId && !subPart.part.allFeaturesReceived) {
          neededParts.push(subPart.part)
        }
      });
      // console.log("neededParts", neededParts);
    }
  }
  if (neededFeatureGroup && !neededFeatureGroup.allFeaturesReceived) {
    neededParts.push(neededFeatureGroup)
  }
  neededParts = neededParts.filter(fg => !fg.allFeaturesReceived);
  if (onlyReturnGroups) {
    return neededParts
  }
  const responses = await Promise.all([
    ...neededParts.map(async relatedItem => await getAdditionalFeaturesOnScroll(relatedItem, true)),
  ]);

  if (isVanityChild) {
    layout.createCustomConfigurations();
  }

  if (shouldUpdateNavigation) {
    store.dispatch(updateFeatureGroupCount());
    store.dispatch(updateNavigationCount())
  }

  return responses
};

export const getFeatureFromTheBackendBySku = async (skuFromUrl, featureGroupFromUrl) => {
  let featureFound;
  const requestFirstSharedFeaturenames = document.kvConfig.visualizerType !== "bvLook"; // for bv look skus are first
  const response = await getBvFeatures(null, [skuFromUrl], requestFirstSharedFeaturenames);
  if (response) {
    let featuresLoaded = response.data || [];
    const layout = getCurrentLayout();
    layout.loadNewFeatures(featuresLoaded);
    const featureGroupPartId = featureGroupFromUrl ? featureGroupFromUrl.replace(/-/gi, "_") : "";
    featureFound = layout.getFeatureBySku(skuFromUrl, featureGroupPartId, false, requestFirstSharedFeaturenames);
    if (!featuresLoaded.length || !featureFound) {
      const response2 = await getBvFeatures(null, [skuFromUrl], !requestFirstSharedFeaturenames);
      if (response2 && Array.isArray(response2.data) && response2.data.length) {
        layout.loadNewFeatures( response2.data);
        featureFound = layout.getFeatureBySku(skuFromUrl, featureGroupPartId, false, !requestFirstSharedFeaturenames);
      }
    }
  }
  return featureFound
}
